<template>
  <div>
    <div class="sida-accordion pre-cadastro-produtor-propriedades">
      <div
        v-for="(item, index) in items"
        :key="index"
        :class="{item, active: index === activeItem}"
        @click="activeItem = index"
        class="accordion-item"
        :data-index="index"
      >
        <h1 class="accordion-title">
          {{ item.nome || ('Propriedade ' + (index + 1)) }}
          <button
            class="btn-delete"
            v-if="items.length > 1 && !item.codigo_sidagro"
            @click="onDeletePropriedadeClick($event, index)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </h1>
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Nome da propriedade</label>
                  <input type="text" class="form-control" v-model="item.nome" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Área total (hectares)</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.lazy="item.area_total"
                    v-money="hectareMask"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label>Tem energia elétrica?</label>
                  <select class="form-control" v-model="item.tem_energia">
                    <option value>Selecione</option>
                    <option value="sim">Sim</option>
                    <option value="nao">Não</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <h3>Endereço</h3>
              <div class="col-md-2">
                <div class="form-group required">
                  <label for="cep">CEP</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="cep"
                    v-mask="['##.###-###']"
                    v-model="item.cep"
                    @blur="onBlurCep(index)"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="logradouro">Logradouro</label>
                  <input
                    type="text"
                    class="form-control"
                    name="logradouro"
                    v-model="item.logradouro"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group required">
                  <label for="numero_propriedade">Número</label>
                  <input
                    type="text"
                    class="form-control numbers-only"
                    name="numero_propriedade"
                    id="numero_propriedade"
                    v-model="item.numero_propriedade"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group required">
                  <label for="bairro">Bairro</label>
                  <input type="text" class="form-control" name="bairro" v-model="item.bairro" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="distrito">Complemento</label>
                  <input
                    type="text"
                    class="form-control"
                    name="complemento_propriedade"
                    v-model="item.complemento"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <label for="distrito">Distrito</label>
                  <input type="text" class="form-control" name="distrito" v-model="item.distrito" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <label for="municipio">Município</label>
                  <input type="text" class="form-control" name="municipio" v-model="item.municipio" />
                  <input type="hidden" class="form-control" name="cod_municipio" v-model="item.cod_municipio" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group required">
                  <label for="estado">UF</label>
                  <input type="text" class="form-control" name="estado" v-model="item.estado" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group required">
                  <label for="latitude">Latitude (<i>Ex.: -3.7614</i>)</label>
                  <input
                    type="text"
                    class="form-control"
                    name="latitude"
                    v-model="item.latitude"
                    @blur="onBlurLatitude(index)"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <label for="longitude">Longitude (<i>Ex.: -38.4744</i>)</label>
                  <input
                    type="text"
                    class="form-control"
                    name="longitude"
                    v-model="item.longitude"
                    @blur="onBlurLongitude(index)"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label for="confrontantes">Confrontantes</label>
                  <textarea
                    style="height: 70px"
                    class="form-control textaera01"
                    name="confrontantes"
                    id="confrontantes"
                    v-model="item.confrontantes"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label for="vias_acesso">Vias de Acesso</label>
                  <textarea
                    style="height: 70px"
                    class="form-control"
                    name="vias_acesso"
                    id="vias_acesso"
                    v-model="item.vias_acesso"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <h3>Documento da propriedade</h3>
              <div class="col-md-6">
                <div :class="{'form-group': true, required: !(item.codigo_sidagro && item.document)}">
                  <label for="documento_propriedade">Insira o anexo</label>
                  <template v-if="item.codigo_sidagro && item.document.cod_anexo">
                    <a
                      :href="getFile2(item.document.cod_anexo)"
                      target="_blank"
                    >Visualizar arquivo</a>
                    <small>Caso deseje alterar, escolha um novo arquivo:</small>
                  </template>
                  <input
                    type="file"
                    class="form-control"
                    :name="'documento_propriedade[' + index + ']'"
                    id="documento_propriedade"
                    accept="application/pdf, image/*"
                  />
                  <small>* Certidão imobiliária atualizada ou documento comprobatório da aquisição do domínio mesmo que ainda não levado a registro ou contrato de arrendamento, contrato de comodato, contrato de parceria ou contrato de meação da propriedade, desde que o documento apresentado possua registro em cartório ou documento não passível de registro imobiliário que comprove a posse ou a transmissão do domínio da área, assinado pela autoridade competente, ou termo de anuência.</small>
                </div>
              </div>
            </div>

            <div class="row">
              <h3>Explorações</h3>
              <pre-cadastro-produtor-exploracao
                @save="onSavePropriedades"
                :exploration-list="item.exploracoes"
              ></pre-cadastro-produtor-exploracao>
            </div>

            <div class="row">
              <h3>Campos adicionais:</h3>
              <div
                class="col-md-6"
                v-if="item.exploracoes.some(exploration => exploration.explorationType === 'ANIMAL')"
              >
                <div class="form-group required">
                  <label>Tipo de atividade</label>
                  <select
                    class="form-control"
                    v-model="item.cod_tipo_atividade"
                    @change="onChangeTipoAtividade($event, item)"
                  >
                    <option value>Selecione</option>
                    <option
                      v-for="(tipoAtividade, index) in tiposAtividade"
                      :key="index"
                      :value="tipoAtividade.id"
                    >{{ tipoAtividade.nome }}</option>
                  </select>
                </div>
              </div>
              <div
                class="col-md-6"
                v-if="item.exploracoes.some(exploration => exploration.explorationType === 'VEGETAL')"
              >
                <div class="form-group">
                  <label>Responsável técnico</label>
                  <input type="text" class="form-control" v-model="item.responsavel" />
                </div>
              </div>
              <div
                class="col-md-6"
                v-if="item.exploracoes.some(exploration => exploration.explorationType === 'VEGETAL')"
              >
                <div :class="{'form-group': true, required: item.responsavel !== ''}">
                  <label>Número do responsável</label>
                  <input type="text" class="form-control" v-model="item.numero_responsavel" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="btn-primary" @click="onAddPropriedadeClick">
      <span>Adicionar Propriedade</span>
    </div>
    <input type="hidden" name="propriedades_json" :value="JSON.stringify(items)" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: false
    }
  },
  data: () => ({
    items: [],
    activeItem: null,
    tiposAtividade: [],
    hectareMask: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: " ha",
      precision: 2
    },

  }),
  watch: {
    data: function() {
      this.loadItems();
    }
  },
  methods: {
     getFile2: function(codAnexo) {
      return "/public/download-file/cod-anexo/" + btoa(codAnexo);
    },
    onAddPropriedadeClick() {
      const emptyItem = {
        nome: "",
        cod_tipo_atividade: "",
        tipo_atividade: "",
        area_total: "",
        tem_energia: "",
        cep: "",
        logradouro: "",
        numero_propriedade: "",
        bairro: "",
        distrito: "",
        complemento: "",
        municipio: "",
        cod_municipio: "",
        estado: "",
        exploracoes: [],
        responsavel: "",
        numero_responsavel: "",
        latitude: "",
        longitude: ""
      };
      this.items.push(emptyItem);
      setTimeout(() => {
        this.activeItem = this.items.length - 1;
      }, 250);
    },
    onSavePropriedades(ev) {
      this.items[this.activeItem].exploracoes = ev;
    },
    getTiposAtividade(count = 0) {
      if (count > 3) {
        alert("Erro ao buscar atividades. Tente novamente mais tarde.");
      }

      axios
        .get("/produtor/pre-cadastro/get-tipos-atividade")
        .then(response => response.data)
        .then(response => {
          const { data } = response;
          this.tiposAtividade = data;
        })
        .catch(error => {
          console.log("error", error);
          this.getTiposAtividade(count++);
        });
    },
    onBlurCep(index) {
      const cep = this.items[index].cep.replace("-", "").replace(".", "");
      if (cep.length < 8) {
        this.items[index].cep = "";
        return;
      }

      this.items[index].logradouro = "Carregando...";
      this.items[index].bairro = "Carregando...";
      this.items[index].municipio = "Carregando...";
      this.items[index].estado = "Carregando...";

      window.loadAddressByCep(cep, (data) => {
        this.items[index].cep = data.cep;
        this.items[index].logradouro = data.logradouro;
        this.items[index].bairro = data.bairro;
        this.items[index].municipio = data.localidade;
        this.items[index].cod_municipio = data.ibge;
        this.items[index].estado = data.uf;

        data.error && this.$toast.error("CEP inválido");
      });
    },
    onDeletePropriedadeClick(ev, index) {
      ev.preventDefault();
      const name = this.items[index].nome || "Propriedade " + (index + 1);
      Swal.fire({
        title: "Deseja mesmo remover a propriedade " + name + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#9b9b9b",
        cancelButtonColor: "#31813c",
        confirmButtonText: "Deletar!"
      }).then(result => {
        if (result.value) {
          this.items.splice(index, 1);
        }
      });
    },
    onChangeTipoAtividade(ev, item) {
      const tipoAtividade = this.tiposAtividade.find(
        item => item.id == ev.target.value
      );
      if (tipoAtividade) {
        item.tipo_atividade = tipoAtividade.nome;
      } else {
        item.tipo_atividade = "";
      }
    },
    onBlurLatitude(index) {
      if (
        this.items[index].latitude &&
        !parseFloat(this.items[index].latitude)
      ) {
        this.items[index].latitude = "";
        alert("Latidude em formáto inválido! Exemplo correto: -3.7614452");
      }
    },

    onBlurLongitude(index) {
      if (
        this.items[index].longitude &&
        !parseFloat(this.items[index].longitude)
      ) {
        this.items[index].longitude = "";
        alert("Longitude em formáto inválido! Exemplo correto: -38.4744683");
      }
    },

    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    adjustLoadedExplorations(exploracoesAnimal, exploracoesVegetal) {
      let exploracoes = [];

      Object.keys(exploracoesVegetal).forEach(key => {
        const exploracoesCultura = exploracoesVegetal[key];
        const adjustedEsplorations = exploracoesCultura.map(item => {
          item.explorationType = "VEGETAL";
          item.saved = true;
          // Vegetal
          item.variedade_id = item.cod_variedade;
          item.cultura_id = item.cod_cultura;
          item.quantidade = item.qtd;
          item.variedades = [];
          // Animal
          item.tipoExploracao = "";
          item.nomeTipoExploracao = "";
          item.faixasEtarias = [];
          return item;
        })
        exploracoes = [...exploracoes, ...adjustedEsplorations];
      });

      Object.keys(exploracoesAnimal).forEach(key => {
        const exploracoesPropriedade = exploracoesAnimal[key];
        const adjustedEsplorations = exploracoesPropriedade.map(item => {
          item.explorationType = "ANIMAL";
          item.saved = true;
          // Vegetal
          item.variedade_id  = "";
          item.nome_variedade  = "";
          item.cultura_id  = "";
          item.nome_cultura  = "";
          item.necessita_rt  = "";
          item.rt_name  = "";
          item.rt_cpf  = "";
          item.quantidade  = "";
          item.variedades  = [];
          // Animal
          item.tipoExploracao  = item.cod_exploracao ? String(item.cod_exploracao) : null;
          item.nomeTipoExploracao  = item.nome;
          item.faixasEtarias  = [];

          return item;
        })
        exploracoes = [...exploracoes, ...adjustedEsplorations];
      });

      return exploracoes;
    },
    loadItems() {
      this.items = [];
      if (this.data && this.data.length) {
        this.items = this.data.map(item => {
          item.tem_energia = item.energia_eletrica ? 'sim' : 'nao';
          item.numero_propriedade = item.numero;
          item.exploracoes = this.adjustLoadedExplorations(item.propertie_explorations_animal, item.propertie_explorations_vegetal);
          return item;
        });
      } else {
        const emptyItem = {
          nome: "",
          cod_tipo_atividade: "",
          tipo_atividade: "",
          area_total: "",
          tem_energia: "",
          cep: "",
          logradouro: "",
          numero_propriedade: "",
          bairro: "",
          distrito: "",
          complemento: "",
          municipio: "",
          cod_municipio: "",
          estado: "",
          exploracoes: [],
          responsavel: "",
          numero_responsavel: "",
          latitude: "",
          longitude: ""
        };
        this.items.push(emptyItem);
      }
      this.activeItem = 0;
    }
  },
  mounted() {
    const scope = this;
    this.getTiposAtividade();
    this.loadItems();

    $(document).on(
      "focus",
      ".pre-cadastro-produtor-propriedades .form-group.required .form-control",
      function(ev) {
        const accordionItem = ev.target.closest(".accordion-item");
        const index = parseInt(accordionItem.getAttribute("data-index"));
        scope.activeItem = index;
      }
    );
  }
};
</script>
<style lang="scss" scoped>
.textaera01 {
  height: 120px;
}
</style>
